import { Injectable } from '@angular/core';
import { UrlService } from '../../contants/url-service.constant';
import { HttpCustom } from '../http/http-custom.service';
import { AgenteService } from '../agente/agente.service';
import { FiltroBuscarCliente } from '../../models/filtro/filtro-buscar-cliente';
import { TipoDocumento } from '../../models/tipo/tipo-documento.class';
import { Ciudad } from '../../models/tipo/ciudad.class';
import { Ocupacion } from '../../models/tipo/ocupacion.class';
import { RegistroCliente } from '../../models/cliente/registro-cliente.class';
import { InformacionCliente } from '../../models/cliente/informacion-cliente.class';
import { RegistroProspecto } from '../../models/prospecto/registro-prospecto.class';
import { HeaderPeticion } from '../../models/http/headerPeticion.class';
import { Configuracion } from '../../contants/configuracion.constant';

@Injectable()
export class ClienteService {
  public static readonly TIPO_DOCUMENTO_NATURAL = 'N';
  public static readonly TIPO_DOCUMENTO_JURIDICO = 'J';
  public static readonly TIPO_DOCUMENTO_TODOS = 'T';

  private filtroBuscarCliente: FiltroBuscarCliente = null;
  private productoSeleccionado: String;
  private cliente = new RegistroCliente();

  constructor(
    private httpCustom: HttpCustom,
    private agenteService: AgenteService
  ) {}

  getListTipoDocumento(
    codigoPais = this.agenteService.getCodigoPais(),
    grupoPersona = this.agenteService.getgrupoPersona()
  ): Promise<TipoDocumento[]> {
    return new Promise((resolve, reject) => {
      this.httpCustom
        .getServiceWithHeaders(
          UrlService.TIPO_DOCUMENTOS,
          {
            codigoPaisOrigen: codigoPais,
            grupo: grupoPersona,
          },
          [
            new HeaderPeticion(
              Configuracion.HEADER_DESCRIPCION_PETICION,
              'Cargando Tipos de Documento'
            ),
          ]
        )
        .subscribe(
          (result) => {
            return resolve(result);
          },
          (error) => {
            return reject([]);
          }
        );
    });
  }

  consultarCliente(filtro: FiltroBuscarCliente): Promise<InformacionCliente> {
    return new Promise((resolve, reject) => {
      this.httpCustom
        .postServiceWithHeaders(UrlService.CONSULTAR_CLIENTE, filtro, [
          new HeaderPeticion(
            Configuracion.HEADER_DESCRIPCION_PETICION,
            'Realizando Consulta del Cliente'
          ),
        ])
        .subscribe(
          (result) => {
            return resolve(result);
          },
          (error) => {
            return reject(error);
          }
        );
    });
  }

  getListCiudad(): Promise<Ciudad[]> {
    return new Promise((resolve, reject) => {
      this.httpCustom
        .getServiceWithHeaders(
          UrlService.CIUDADES,
          { codigoPais: this.agenteService.getCodigoPais() },
          [
            new HeaderPeticion(
              Configuracion.HEADER_DESCRIPCION_PETICION,
              'Cargando Lista de Ciudades'
            ),
          ]
        )
        .subscribe(
          (result) => {
            return resolve(result);
          },
          (error) => {
            return reject([]);
          }
        );
    });
  }

  getOcupaciones(): Promise<Ocupacion[]> {
    return new Promise((resolve, reject) => {
      this.httpCustom
        .getServiceWithHeaders(UrlService.OCUPACIONES, {}, [
          new HeaderPeticion(
            Configuracion.HEADER_DESCRIPCION_PETICION,
            'Cargando Ocupaciones'
          ),
        ])
        .subscribe(
          (result) => {
            return resolve(result);
          },
          (error) => {
            return reject([]);
          }
        );
    });
  }

  guardarCliente(cliente: RegistroCliente) {
    return new Promise((resolve, reject) => {
      this.httpCustom
        .postServiceWithHeaders(UrlService.GUARDAR_CLIENTE, cliente, [
          new HeaderPeticion(
            Configuracion.HEADER_DESCRIPCION_PETICION,
            'Guardando el Cliente'
          ),
        ])
        .subscribe(
          (result) => {
            resolve(true);
          },
          (error) => {
            reject(false);
          }
        );
    });
  }

  guardarClienteProspecto(cliente: RegistroProspecto): Promise<any> {
    return new Promise((resolve, reject) => {
      this.httpCustom
        .postServiceWithHeaders(UrlService.GUARDAR_CLIENTE_PROSPECTO, cliente, [
          new HeaderPeticion(
            Configuracion.HEADER_DESCRIPCION_PETICION,
            'Guardando el Cliente'
          ),
        ])
        .subscribe(
          (result) => {
            resolve(result);
          },
          (error) => {
            reject(error);
          }
        );
    });
  }

  getTiposDocumentosXCliente(
    tipoDocumento: String,
    listTipoDocumento: TipoDocumento[]
  ) {
    let tipoDocumentoFiltrado = listTipoDocumento;
    if (ClienteService.TIPO_DOCUMENTO_NATURAL === tipoDocumento.toUpperCase()) {
      tipoDocumentoFiltrado = listTipoDocumento.filter(
        (documento) =>
          documento.tipoPersona.toUpperCase() !==
          ClienteService.TIPO_DOCUMENTO_JURIDICO
      );
    }
    return tipoDocumentoFiltrado;
  }

  limpiarFiltros() {
    this.filtroBuscarCliente = null;
  }

  getfiltroBuscarCliente(): FiltroBuscarCliente {
    return this.filtroBuscarCliente;
  }

  setfiltroBuscarCliente(filtro: FiltroBuscarCliente) {
    this.filtroBuscarCliente = filtro;
  }

  getProductoSeleccionado() {
    return this.productoSeleccionado;
  }

  setProductoSeleccionado(producto) {
    this.productoSeleccionado = producto;
  }

  getCliente() {
    return this.cliente;
  }

  setCliente(cliente) {
    this.cliente = cliente;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/cliente/cliente.service.ts